import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/start';
import TopicSso from './topics/sso';
import TopicIcs from './topics/ics';
import TopicPsa from './topics/psa';
import TopicUats from './topics/uats';
import TopicTpv from './topics/tpv';
import TopicQuiz from './topics/topicQuiz';
import './index.less';
import './index.mobile.less';
import './index.en.less';

export interface IGeneralStaffProps {
  topicName: string;
  topicSettings: any;
}

export function SME(props: IGeneralStaffProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/ics"
        element={<TopicIcs settings={props.topicSettings} />}
      />
      <Route
        path="/sso"
        element={<TopicSso settings={props.topicSettings} />}
      />
      <Route
        path="/psa"
        element={<TopicPsa settings={props.topicSettings} />}
      />
      <Route
        path="/uats"
        element={<TopicUats settings={props.topicSettings} />}
      />
      <Route
        path="/tpv"
        element={<TopicTpv settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
